'use client';

import { type FC, useState } from 'react';
import { Credits } from '../../components/Credits';
import { Cell, List } from '../../components/ui';
import { useLocalTranslation } from '../../hooks/useLocalTranslation';
import { formatCreditsNumber } from '../../utils/formatters';
import translations from './ReferralScreen.translations';
import { ReferralRulesSheet } from './ReferralRulesSheet';
import { RiInformationLine } from '../../components/icons';

interface ReferralStatsBlockProps {
  totalReferrals: number;
  totalEarned: number;
  rewardCredits: number;
  showStats?: boolean;
}

export const ReferralStatsBlock: FC<ReferralStatsBlockProps> = ({
  totalReferrals,
  totalEarned,
  rewardCredits,
  showStats = true,
}) => {
  const { t } = useLocalTranslation(translations);
  const [rulesOpen, setRulesOpen] = useState(false);

  return (
    <div className="px-4">
      {showStats && totalReferrals > 0 && (
        <div className="grid grid-cols-2 gap-3 mb-6">
          <div className="rounded-[22px] bg-bg-secondary px-4 py-4 flex flex-col items-center">
            <span className="text-[13px] text-label-secondary">{t('statsInvited')}</span>
            <span className="text-[28px] leading-tight font-bold text-label-primary mt-1">{formatCreditsNumber(totalReferrals)}</span>
          </div>
          <div className="rounded-[22px] bg-bg-secondary px-4 py-4 flex flex-col items-center">
            <span className="text-[13px] text-label-secondary">{t('statsEarned')}</span>
            <Credits amount={totalEarned} iconSize={20} className="text-[28px] leading-tight font-bold text-label-primary mt-1" />
          </div>
        </div>
      )}

      <List className="mb-6">
        <Cell
          before={<RiInformationLine />}
          chevron
          tone="accent"
          accentColor="var(--color-accent-blue)"
          data-sound="menu_select"
          onClick={() => setRulesOpen(true)}
        >
          {t('statsRulesButton')}
        </Cell>
      </List>

      <ReferralRulesSheet
        isOpen={rulesOpen}
        onClose={() => setRulesOpen(false)}
        rewardCredits={rewardCredits}
      />
    </div>
  );
};
